<template>
  <div class="container">

    <!-- 介绍 -->
    <div class="interduce">
      <TopPage :content="data.topIntroduce"></TopPage>
      <!-- <img @load="loadImg0" class="image" :src="images[0].imageSrc" mode="aspectFill"/>
      <div class="more" v-if="showIntroduceContent">
        <div class="title">{{ topIntroduce.title }}</div>
        <img :src="topIntroduce.arrowSmall" mode="aspectFill">
      </div> -->
      <div class="container-scroll">
       <AutoScrollView></AutoScrollView>
      </div>
    </div>

    <!-- 产品介绍 -->
    <div class="product_interduction">
     <!-- <img @load="loadImg1" class="image" :src="images[1].imageSrc" mode="aspectFill"/> -->
      <ProductIntroduceAndCase :data="data.productIntroduce.intro"></ProductIntroduceAndCase>
      <div class="interduction_list">
        <div @click="productInterductionItemAction(item, index)" class="item" v-for="(item, index) in data.productIntroduce.list" :key="index">
          <div class="title">{{ item.title }}</div>
          <img :src="data.productIntroduce.arrowBlue" alt="">
        </div>
      </div>
      <div class="content">
        <LeftAside
          ref="interduceLeftAside"
          :title="data.productIntroduce.title"
          :items="data.productIntroduce.list"
          @itemAction="productInterductionItemAction">
        </LeftAside>
        <div class="right">
          <div
            v-for="(item, index) in data.productIntroduce.list"
            :key="index"
            :ref="`introduceScrollRef${index}`"
            :id= "`introduceScrollId${index}`"
            >
            <ScorllView :key='`${index+1}`' :info="item"></ScorllView>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品案例 -->
    <div class="product_case">
     <!-- <img @load="loadImg2" class="image" :src="images[2].imageSrc" mode="aspectFill"/> -->
      <ProductIntroduceAndCase :data="data.productCase.intro"></ProductIntroduceAndCase>
      <div class="case_list">
        <div @click="productCaseItemAction(item, index)" class="item" v-for="(item, index) in data.productCase.list" :key="index">
          <div class="title">{{ item.title }}</div>
          <img :src="data.productCase.arrowBlue" alt="">
        </div>
      </div>
      <div class="content">
        <LeftAside
          ref="caseLeftAside"
          :title="data.productCase.title"
          :items="data.productCase.list"
          @itemAction="productCaseItemAction">
        </LeftAside>
        <div class="right">
          <div
            v-for="(item, index) in data.productCase.list"
            :key="index"
            :ref="`caseScrollRef${index}`"
            :id= "`caseScrollId${index}`"
            >
            <Pannel :detail="item"></Pannel>
            <HighlightsScrollView :info="item"></HighlightsScrollView>
            <ShowingStand v-if="index==3" :array="data.productCase.showingStandArray"></ShowingStand>
          </div>
        </div>
      </div>
    </div>

    <!-- <img class="image" :src="images[3].imageSrc" mode="aspectFill"/>
    <img class="image" :src="images[4].imageSrc" mode="aspectFill"/>
    <img class="image" :src="images[5].imageSrc" mode="aspectFill"/> -->

    <!--我们的优势-->
    <OurAdvantage :ourAdvantageInfo="data.ourAdvantage"></OurAdvantage>

    <!--我们的使命-->
    <OurMission :ourMissionInfo="data.ourMission"></OurMission>

    <!--关于我们-->
    <AboutUs :aboutUsInfo="data.aboutUs"></AboutUs>

  </div>
</template>

<script>
import AutoScrollView from '@/components/content/autoScrollView/autoScrollView.vue'
import ScorllView from './childComps/ScorllView.vue'
import HighlightsScrollView from "./childComps/HighlightsScrollView.vue"
import Pannel from './childComps/Pannel.vue'
import LeftAside from './childComps/LeftAside.vue'
import ShowingStand from './childComps/ShowingStand.vue'
import OurAdvantage from "./childComps/OurAdvantage.vue"
import OurMission from "./childComps/OurMission.vue"
import AboutUs from "./childComps/AboutUs.vue";
import ProductIntroduceAndCase from "./childComps/ProductIntroduceAndCase.vue";
import TopPage from '@/components/content/topPage/TopPage.vue'

import data from '@/common/json/homepage.js'

export default {
    components: {
      AutoScrollView,
      ScorllView,
      HighlightsScrollView,
      Pannel,
      LeftAside,
      ShowingStand,
      OurAdvantage,
      OurMission,
      AboutUs,
      ProductIntroduceAndCase,
      TopPage
    },
    data() {
        return {
          data: {},
          images: [
            { imageSrc: require("@/assets/homepage/home_part1@2x.jpg") },
            { imageSrc: require("@/assets/homepage/home_part2@2x.jpg") },
            { imageSrc: require("@/assets/homepage/home_part3@2x.jpg") },
            { imageSrc: require("@/assets/homepage/home_part4@2x.jpg") },
            { imageSrc: require("@/assets/homepage/home_part5@2x.jpg") },
            { imageSrc: require("@/assets/homepage/home_part6@2x.jpg") }
          ],
          showIntroduceContent: false,
          showProductIntroductionContent: false,
          showProductCaseContent: false,
          isScrollGet: true,
        };
    },
    created() {
      this.setCurrentLanguage()
    },
    mounted() {
      window.addEventListener("scroll",this.scrollGet, true)
    },
    methods: {
      
      setCurrentLanguage() {
        const languageJson = {
          'zh-CN':data.data_CN,
          'en-US':data.data_EN,
          'ja':data.data_JA,
        }
        const languageStr = sessionStorage.getItem('currentLanguage') || 'ja'
        console.log('current',sessionStorage.getItem('currentLanguage'))
        this.data = languageJson[languageStr]
      },

      // 图片加载完成
      loadImg0() {
        this.showIntroduceContent = true
      },

      // 图片加载完成
      loadImg1() {
        this.showProductIntroductionContent = true
      },

      // 图片加载完成
      loadImg2() {
        this.showProductCaseContent = true
      },

      // 产品简介item点击事件
      productInterductionItemAction(item, index) {
        this.isScrollGet = false
        setTimeout(() => {
          this.isScrollGet = true
        }, 600);
        this.$refs.interduceLeftAside.setCurrentIndex(index)
        let offsetY = (document.documentElement.clientWidth / 1920) * (70 + 35)
        this.$scrollTo(`#introduceScrollId${index}`, 500, {
          offset: -offsetY // 滚动位置向上偏移100
        })
      },

      // 产品案例item点击事件
      productCaseItemAction(item, index) {
        this.isScrollGet = false
        setTimeout(() => {
          this.isScrollGet = true
        }, 600);
        this.$refs.caseLeftAside.setCurrentIndex(index)
        let offsetY = (document.documentElement.clientWidth / 1920) * (70 + 35)
        this.$scrollTo(`#caseScrollId${index}`, 500, {
          offset: -offsetY // 滚动位置向上偏移100
        })
      },

      // 监听页面滚动
      scrollGet() {
        if (!this.isScrollGet) return

        let offsetY = (document.documentElement.clientWidth / 1920) * (70+35)

        let introduceScrollIdBeginTop = document.getElementById("introduceScrollId0").getBoundingClientRect().top
        let caseScrollIdBeginTop = document.getElementById("caseScrollId0").getBoundingClientRect().top

        // 缩小代码的执行区域
        if (introduceScrollIdBeginTop <= 0 && caseScrollIdBeginTop >0 ) {
          for (let i = this.data.productIntroduce.list.length - 1; i >= 0; i--) {
            let top = document.getElementById(`introduceScrollId${i}`).getBoundingClientRect().top
            // console.log("introduceScrollId",i, top, offsetY)
            if (top <=  (i == 0 ? 0 : offsetY)) {
              this.$refs.interduceLeftAside.setCurrentIndex(i)
              break
            }
          }
        }

        if (caseScrollIdBeginTop <= 0) {
          for (let i = this.data.productCase.list.length - 1; i >= 0; i--) {
            let top = document.getElementById(`caseScrollId${i}`).getBoundingClientRect().top
            // console.log("caseScrollId",i, top, offsetY)
            if (top <=  (i == 0 ? 0 : offsetY)) {
              this.$refs.caseLeftAside.setCurrentIndex(i)
              break
            }
          }
        }
      }                                             
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollGet, true)
    }
}
</script>

<style lang="scss" scoped>

.image {
  width: 100%;
}

.container{
  z-index: 1;
  position: relative;

  .interduce {
    width: 100%;
    position: relative;

    .more {
      position: absolute;
      left: 232px;
      bottom: 275px;
      height: 47px;
      display: flex;
      align-items: center;

      .title {
        margin-right: 15px;
        font-size: 24px;
        font-family: FZLanTingHeiS-R-GB-Regular, FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #EAFF74;
      }

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .product_interduction {
    padding-top: 97px;
    width: 100%;
    .interduction_list {
      display: flex;
      flex-wrap: wrap;
      padding-left: 109px;
      padding-bottom: 77px;

      .item {
        padding: 18px 32px;
        margin-bottom: 20px;

        background-color: #E8EEFC;
        border-radius: 48px;
        display: flex;
        align-items: center;
        margin-right: 40px;
        flex-wrap: wrap;

        .title {
          font-size: 24px;
          font-family: "SourceHanSansSC-Heavy-2";
          font-weight: 800;
          color: #2A45A7;
          margin-right: 12px;
        }

        img {
          width: 24px;
          height: 24px;
        }

        &:hover {
          background-color: rgba(232,238,252,0.5);
          cursor: pointer;
        }
      }

      
    }

    .content {
      display: flex;
      padding-bottom: 180px;

      .right {
        margin-left: 73px;
        div {
          margin-top: 180px;
        }
      }
    }
  }

  .product_case {
    width: 100%;
    background-color: #E8EEFC;
    padding-top: 97px;

    .case_list {
      display: flex;
      padding-left: 109px;
      padding-bottom: 77px;
      flex-wrap: wrap;

      .item {
        padding: 18px 18px;
        margin-bottom: 20px;
        background-color: #EAFF74;
        border-radius: 48px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-right: 40px;

        .title {
          font-size: 24px;
          font-family: "SourceHanSansSC-Heavy-2";
          font-weight: 800;
          color: #2A45A7;
          margin-right: 12px;
        }

        img {
          width: 24px;
          height: 24px;
        }

        &:hover {
          background-color: rgba(234, 255, 116, 0.5);
          cursor: pointer;
        }
      }
    }

    .content {
      display: flex;
      padding-bottom: 124px;

      .right {
        margin-left: 73px;
      }
    }
  }
}

.container-scroll{
  height:100%;
  display: flex;
  align-items: flex-start !important;
  justify-content: flex-end !important;
  padding: 0;
  z-index: 100;
  position: absolute;
  top :0;
  right :0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/HomePage.vue